import { http } from '../../http';
import omit from "lodash/omit";

export default {
    state: {
        giftcards: {},
        pagination: {},
        loaded: false,
        loading: false
    },

    mutations: {
        addGiftcard (state, giftcard) {
            return state.giftcards.push(giftcard);
        },
        setLoaded(state) {
            state.loaded = true;
        },

        setGiftcards(state, data) {
            state.giftcards = data.data;
            state.pagination = omit(data, ['data']);
        },

        deleteGiftcard(state, giftcard) {
            var index = state.giftcards.findIndex((element) => {
                return element.id === giftcard.id;
            });

            state.giftcards.splice(index, 1);
        },
    },

    getters: {
        getPagination: (state, getters) => {
            return state.pagination;
        },

        getGiftcards: (state, getters) => {
            return state.giftcards;
        },

        isLoaded: (state, getters) => {
            return state.loaded;
        }
    },

    actions: {
        loadGiftcards (context, query_params) {
            if (context.loaded || context.loading) {
                return;
            }

            http.get('/app/giftcards', { params: query_params })
                .then(({ data }) => {
                    context.commit('setGiftcards', data);
                    context.loading = false;
                    context.commit('setLoaded');
                });
        },

        loadData (context, query_params) {
            context.dispatch('loadGiftcards', query_params);
        },
    }
};
